import { render, staticRenderFns } from "./toolFooter.vue?vue&type=template&id=6980c5a4&scoped=true"
import script from "./toolFooter.vue?vue&type=script&lang=js"
export * from "./toolFooter.vue?vue&type=script&lang=js"
import style0 from "./toolFooter.vue?vue&type=style&index=0&id=6980c5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6980c5a4",
  null
  
)

export default component.exports